import request from '../utils/request';
/**
 * 心跳初始化
 */
export function configuration(params) {
    // 测试环境是 1739e28a7bc100
    // 正式环境是 1739e28a7bc179
    let id = '1739e28a7bc200'
    //海外版
    if (process.env.ENV_CONFIG == 'devOverseas' || process.env.ENV_CONFIG == 'prodOverseas' || process.env.ENV_CONFIG == 'thdev' || process.env.ENV_CONFIG == 'thuat' || process.env.ENV_CONFIG == 'thprod') {
        // return
        id = '1739e28a7bc200'
        if (process.env.ENV_CONFIG == 'thprod' || process.env.ENV_CONFIG == 'prodOverseas') {
            id = '1739e28a7bc279'
        }
      } else {
        // 大陆
        id = '1739e28a7bc100'
        if (process.env.ENV_CONFIG == 'prod') {
            id = '1739e28a7bc179'
        }
    }
    // if (window.location.host == 'm-uat.transtalent.cn') {
    //     appId = '1739e28a7bc100'
    //   }
    return request.LrsService({
        url: `/hb/v1/configuration/${id}`,
        method: 'get',
        data: params
    })
    // appDescription: "V1.0"
    // appId: "1739e28a7bc100"
    // appName: "英跃"
    // appSecret: "dfd2334030814b8999491901a8679030"
    // appTimeInterval: 30
    // expireMinute: 30
    // id: 1
}

/**
 * 心跳接口
 */
 export function heartbeatApi(params) {
    return request.LrsService({
        url: `/hb/v1/heartbeat/`,
        method: 'post',
        data: params
    });
}

/**
 * test
 */
 export function trialFlow(params) {
    return request.MainService({
        url: `/sr/trialFlow/findUserIdByPhone/18616855432`,
        method: 'get',
        data: params
    })
}







// WEBPACK FOOTER //
// ./src/api/heartbeat.js